export default [
  'companycode',
  'countrytaxtype',
  'adjustmenttype',
  'description',
  'amountfrom',
  'frequency',
  'account',
  'annualcumulative',
  'amount',
  'multiplier',
  'booktotaxdescription',
];
